'use client';

import { LinkList, StarRating } from '@petsmart-ui/sparky';
import { useScrollToSection } from '@libs/common-next';

import type { ProductRatingsProps } from './types';
import { useProductRatingsMapper } from './hooks';
import './ProductRatings.scss';

export default function ProductRatings({ product }: ProductRatingsProps) {
    const productRatings = useProductRatingsMapper(product);
    const scrollToSection = useScrollToSection();
    return (
        <StarRating
            className="product-ratings"
            behavior="wrap"
            onClick={() => scrollToSection('bv-reviews')}
            value={productRatings.averageRatings}
            ratingAfter={
                <LinkList variant="lined" behavior="horizontal">
                    <LinkList.Item
                        text={productRatings.numberOfReviewsText}
                        href="#bv-reviews"
                        data-testid="product-ratings-link"
                    />
                </LinkList>
            }
            data-testid="product-ratings"
        />
    );
}
